<template>
  <div class="listing-page map-page">
    <layouts-header></layouts-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <map-filter></map-filter>
    <section class="section car-listing">
      <div class="container-fluid p-0">
        <div class="row gx-0">
          <div class="col-xl-8 col-lg-12">
            <div class="map-list">
              <!-- Sort By -->
              <map-sort></map-sort>
              <!-- /Sort By -->

              <div class="listview-car" v-for="item in Listing_Map" :key="item.id">
                <div class="card">
                  <div class="blog-widget d-flex">
                    <div class="blog-img">
                      <router-link to="listing-details">
                        <img
                          :src="require(`@/assets/img/${item.image}`)"
                          class="img-fluid"
                          alt="Toyota"
                        />
                      </router-link>
                      <div class="fav-item justify-content-end">
                        <span class="img-count"><i class="feather-image"></i>04</span>
                        <a
                          href="javascript:void(0)"
                          class="fav-icon"
                          @click="toggleSelected(item)"
                          :class="{ selected: item.isSelected }"
                        >
                          <i class="feather-heart"></i>
                        </a>
                      </div>
                    </div>
                    <div class="bloglist-content w-100">
                      <div class="card-body">
                        <div class="blog-list-head d-flex">
                          <div class="blog-list-title">
                            <h3>
                              <router-link to="listing-details">{{
                                item.Name
                              }}</router-link>
                            </h3>
                            <h6>
                              Category : <span>{{ item.Category }}</span>
                            </h6>
                          </div>
                          <div class="blog-list-rate">
                            <div class="list-rating">
                              <i class="fas fa-star filled"></i>
                              <i class="fas fa-star filled"></i>
                              <i class="fas fa-star filled"></i>
                              <i class="fas fa-star filled"></i>
                              <i class="fas fa-star"></i>
                              <span>{{ item.Reviews }}</span>
                            </div>
                            <h6>{{ item.price }}<span>/ Day</span></h6>
                          </div>
                        </div>
                        <div class="listing-details-group">
                          <ul>
                            <li>
                              <span
                                ><img
                                  src="@/assets/img/icons/car-parts-01.svg"
                                  alt="Auto"
                              /></span>
                              <p>{{ item.transmission }}</p>
                            </li>
                            <li>
                              <span
                                ><img
                                  src="@/assets/img/icons/car-parts-02.svg"
                                  alt="10 KM"
                              /></span>
                              <p>{{ item.mileage }}</p>
                            </li>
                            <li>
                              <span
                                ><img
                                  src="@/assets/img/icons/car-parts-03.svg"
                                  alt="Petrol"
                              /></span>
                              <p>{{ item.fuel_type }}</p>
                            </li>
                            <li>
                              <span
                                ><img
                                  src="@/assets/img/icons/car-parts-04.svg"
                                  alt="Power"
                              /></span>
                              <p>{{ item.power }}</p>
                            </li>
                            <li>
                              <span
                                ><img
                                  src="@/assets/img/icons/car-parts-06.svg"
                                  alt="Persons"
                              /></span>
                              <p>{{ item.persons }}</p>
                            </li>
                            <li>
                              <span
                                ><img
                                  src="@/assets/img/icons/car-parts-05.svg"
                                  alt="2018"
                              /></span>
                              <p>{{ item.year }}</p>
                            </li>
                          </ul>
                        </div>
                        <div class="blog-list-head list-head-bottom d-flex">
                          <div class="blog-list-title">
                            <div class="title-bottom">
                              <div class="car-list-icon">
                                <img
                                  :src="
                                    require(`@/assets/img/profiles/${item.profile_image}`)
                                  "
                                  alt="user"
                                />
                              </div>
                              <div class="address-info">
                                <h6>
                                  <i class="feather-map-pin"></i>{{ item.location }}
                                </h6>
                              </div>
                              <div class="list-km">
                                <span class="km-count"
                                  ><img
                                    src="@/assets/img/icons/map-pin.svg"
                                    alt="author"
                                  />{{ item.Meter }}</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="listing-button">
                            <router-link to="listing-details" class="btn btn-order"
                              ><span><i class="feather-calendar me-2"></i></span>Rent
                              Now</router-link
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="feature-text">
                      <span :class="item.MakeClass">{{ item.make }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!--Pagination-->
              <div class="blog-pagination">
                <nav>
                  <ul class="pagination page-item justify-content-center">
                    <li class="previtem">
                      <a class="page-link" href="javascript:;"
                        ><i class="fas fa-regular fa-arrow-left me-2"></i> Prev</a
                      >
                    </li>
                    <li class="justify-content-center pagination-center">
                      <div class="page-group">
                        <ul>
                          <li class="page-item">
                            <a class="page-link" href="javascript:;">1</a>
                          </li>
                          <li class="page-item">
                            <a class="active page-link" href="javascript:;"
                              >2 <span class="visually-hidden">(current)</span></a
                            >
                          </li>
                          <li class="page-item">
                            <a class="page-link" href="javascript:;">3</a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li class="nextlink">
                      <a class="page-link" href="javascript:;"
                        >Next <i class="fas fa-regular fa-arrow-right ms-2"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
              <!--/Pagination-->
            </div>
          </div>

          <div class="col-xl-4 col-lg-12 map-right grid-list-map">
            <!-- Map -->
            <div id="map" class="map-listing">
              <GoogleMap
                api-key="YOUR_ACTUAL_API_KEY"
                @click="showInfo(marker)"
                style="width: 100%; height: 500px"
                :center="center"
                :zoom="15"
              >
                <Marker :options="{ position: center }" />
              </GoogleMap>
            </div>
            <!-- /Map-->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
const locations = [
  {
    id: "01",
    car_brand: "Ferrai",
    car_name: "Ferrari 458 MM Special",
    car_image: "car-list-1.jpg",
    reviews: "(4.0) 160",
    address: "Newyork, USA",
    km: "3.0m",
    amount: "$160",
    lat: "53.470692",
    lng: "-2.220328",
    icons: "'car-marker-01.svg'",
    profile_link: "/listing/listing-details",
    image: "avatar-04.jpg",
  },
  {
    id: "02",
    car_brand: "BMW",
    car_name: "BMW 640 XI Gran Turismo",
    car_image: "car-list-2.jpg",
    reviews: "(4.0) 165 ",
    address: "Pattaya, Thailand",
    km: "3.7m",
    amount: "$160",
    lat: "53.469189",
    lng: "-2.199262",
    icons: "'car-marker-01.svg'",
    profile_link: "/listing/listing-details",
    image: "avatar-03.jpg",
  },
  {
    id: "03",
    car_brand: "Ford",
    car_name: "Ford Mustang, Blue 2014",
    car_image: "car-list-3.jpg",
    reviews: "(4.0) 165 ",
    address: "Lasvegas, USA",
    km: "4.0m",
    amount: "$150",
    lat: "53.468665",
    lng: "-2.189269",
    icons: "default",
    profile_link: "/listing/listing-details",
    image: "avatar-06.jpg",
  },
  {
    id: "04",
    car_brand: "Audi",
    car_name: "Audi A3 2019 new",
    car_image: "car-list-5.jpg",
    reviews: "(4.0) 150 ",
    address: "Newyork, USA",
    km: "3.5m",
    amount: "$45",
    lat: "53.463894",
    lng: "-2.17788",
    icons: "default",
    profile_link: "/listing/listing-details",
    image: "avatar-03.jpg",
  },
  {
    id: "05",
    car_brand: "Ford",
    car_name: "Ford Mustang 4.0 AT",
    car_image: "car-list-6.jpg",
    reviews: "(4.0) 170  ",
    address: "Lasvegas, USA",
    km: "4.1m",
    amount: "$90",
    lat: "53.466359",
    lng: "-2.213314",
    icons: "default",
    profile_link: "/listing/listing-details",
    image: "avatar-03.jpg",
  },
];

const icons = {};

import Listing_Map from "@/assets/json/listing-map.json";
import { defineComponent } from "vue";
import { GoogleMap, Marker } from "vue3-google-map";

/* eslint-disable */

// Declare google as a global variable
/* global google */

export default defineComponent({
  setup() {
    const center = { lat: 40.689247, lng: -74.044502 };

    return { center };
  },
  components: { GoogleMap, Marker },
  data() {
    return {
      Listing_Map: Listing_Map,
      title: "Car Listings",
      text: "Listings",
      text1: "Listings Map",
      Sort: ["Default", "10 AM - 12 PM", "12 PM - 2 PM", "02 PM - 04 PM"],
      icons: icons,
      locations: locations,
      isSelected: false,
    };
  },
  methods: {
    showInfo(marker) {
      this.infoWindowPosition = marker.position;
      this.infoWindowOpened = true;
      this.setInfo(marker);
    },
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
  },
  mounted() {
    // Your Google Maps related code here
    google.maps.visualRefresh = true;
    var slider,
      infowindow = null;
    var bounds = new google.maps.LatLngBounds();
    var map,
      current = 0;

    function show() {
      infowindow.close();
      if (!map.slide) {
        return;
      }
      var next, marker;
      if (locations.length == 0) {
        return;
      } else if (locations.length == 1) {
        next = 0;
      }
      if (locations.length > 1) {
        do {
          next = Math.floor(Math.random() * locations.length);
        } while (next == current);
      }
      current = next;
      marker = locations[next];
      setInfo(marker);
      infowindow.open(map, marker);
    }

    function initialize() {
      var bounds = new google.maps.LatLngBounds();
      var mapOptions = {
        zoom: 14,
        center: new google.maps.LatLng(53.470692, -2.220328),
        scrollwheel: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      };

      map = new google.maps.Map(document.getElementById("map"), mapOptions);
      map.slide = true;

      setMarkers(map, locations);
      infowindow = new google.maps.InfoWindow({
        content: "loading...",
      });
      google.maps.event.addListener(infowindow, "closeclick", function () {
        infowindow.close();
      });
      slider = window.setTimeout(show, 3000);
    }

    function setInfo(marker) {
      var content =
        '<div class="listing-item" style="width: 100%; display: inline-block;">' +
        '<div class="listing-img">' +
        '<a href="' +
        marker.profile_link +
        '">' +
        '<img src="' +
        require(`@/assets/img/${marker.car_image}`) +
        '" class="img-fluid" alt="Audi">' +
        "</a>" +
        '<div class="fav-item justify-content-end">' +
        '<a href="javascript:void(0)" class="fav-icon">' +
        '<i class="feather-heart"></i>' +
        "</a>	" +
        "</div>" +
        '<span class="featured-text">' +
        marker.car_brand +
        "</span>" +
        "</div>" +
        '<div class="listing-content">' +
        '<div class="listing-features d-flex align-items-end justify-content-between">' +
        '<div class="list-rating">' +
        '<a href="javascript:void(0)" class="author-img">' +
        '<img src="' +
        require(`@/assets/img/profiles/${marker.image}`) +
        '" class="img-fluid" alt="Audi" />' +
        "</a>" +
        '<h3 class="listing-title">' +
        '<a href="' +
        marker.profile_link +
        '">' +
        marker.car_name +
        "</a>" +
        "</h3>			" +
        '<div class="list-rating">			' +
        '	<i class="fas fa-star filled"></i>' +
        '<i class="fas fa-star filled"></i>' +
        '<i class="fas fa-star filled"></i>' +
        '<i class="fas fa-star filled"></i>' +
        '<i class="fas fa-star"></i>' +
        "<span>" +
        marker.reviews +
        " Reviews</span>" +
        "</div>" +
        "</div>" +
        '<div class="list-km">' +
        '<span class="km-count"><img src=" ' +
        require(`@/assets/img/icons/map-pin.svg`) +
        '" alt="author">' +
        marker.km +
        "</span>" +
        "</div>" +
        "</div> " +
        '<div class="listing-details-group">' +
        "<ul>" +
        "<li>" +
        '<span> + <img src=" ' +
        require(`@/assets/img/icons/car-parts-05.svg`) +
        '" alt="Manual"> +</span>' +
        "<p>Manual</p>" +
        "</li>" +
        "<li>" +
        '<span> + <img src=" ' +
        require(`@/assets/img/icons/car-parts-02.svg`) +
        '" alt="10 KM"> +</span>' +
        "<p>10 KM</p>" +
        "</li>" +
        "<li>" +
        '<span><img src=" ' +
        require(`@/assets/img/icons/car-parts-03.svg`) +
        '" alt="Petrol"></span>' +
        "<p>Petrol</p>" +
        "</li>" +
        "</ul>" +
        "<ul>" +
        "<li>" +
        '<span><img src=" ' +
        require(`@/assets/img/icons/car-parts-04.svg`) +
        '" alt="Power"></span>' +
        "<p>Power</p>" +
        "</li>" +
        "<li>" +
        '<span><img src=" ' +
        require(`@/assets/img/icons/car-parts-05.svg`) +
        '" alt="2019"></span>' +
        "<p>2019</p>" +
        "</li>" +
        "<li>" +
        '<span><img src=" ' +
        require(`@/assets/img/icons/car-parts-04.svg`) +
        '" alt="Persons"></span>' +
        "<p>4 Persons</p>" +
        "</li>" +
        "</ul>" +
        "</div>" +
        '<div class="listing-location-details">' +
        '<div class="listing-price">' +
        '<span><i class="feather-map-pin"></i></span>' +
        marker.address +
        "" +
        "</div>" +
        '<div class="listing-price">' +
        "<h6>" +
        marker.amount +
        "<span>/ Day</span></h6>" +
        "</div>" +
        "</div>" +
        '<div class="listing-button">' +
        '<a href="' +
        marker.profile_link +
        '" class="btn btn-order"><span><i class="feather-calendar me-2"></i></span>' +
        "Rent Now</a>" +
        "</div>" +
        "</div>" +
        "</div>";

      infowindow.setContent(content);
    }

    function setMarkers(map, markers) {
      for (var i = 0; i < markers.length; i++) {
        var item = markers[i];
        var latlng = new google.maps.LatLng(item.lat, item.lng);
        var marker = new google.maps.Marker({
          position: latlng,
          map: map,
          car_name: item.car_name,
          address: item.address,
          car_brand: item.car_brand,
          car_name: item.car_name,
          amount: item.amount,
          profile_link: item.profile_link,
          reviews: item.reviews,
          animation: google.maps.Animation.DROP,
          icons: item.icons,
          image: item.image,
          km: item.km,
          car_image: item.car_image,
        });
        bounds.extend(marker.position);
        markers[i] = marker;
        google.maps.event.addListener(marker, "click", function () {
          setInfo(this);
          infowindow.open(map, this);
          window.clearTimeout(slider);
        });
      }
      map.fitBounds(bounds);
      google.maps.event.addListener(map, "zoom_changed", function () {
        if (map.zoom > 16) map.slide = false;
      });
    }

    google.maps.event.addDomListener(window, "load", initialize);
  },
});
</script>
